import { useSelector } from 'react-redux';
import { selectApps } from '../../../reducers/aiSupportReducer';
import { useAiAssistant } from '../../pages/ai-assistant/useAiAssistant';
import { useRunOnceWhenTruthy } from '../../common/useRunOnceWhenTruthy';

export const useUserSupportAgent = (crmOrgId: string) => {
  const apps = useSelector(selectApps(crmOrgId));
  const { fetchApps, fetchAiAssistentConversations, isLoading, isInitialized } = useAiAssistant();
  const isLaunchedAgent = isInitialized && !isLoading;

  useRunOnceWhenTruthy(() => {
    fetchApps(crmOrgId, true);
    fetchAiAssistentConversations(crmOrgId);
  }, !apps);

  return { isLaunchedAgent, isLoading };
};
